import Vue from 'vue'
import Router from 'vue-router'
import IndexPage from '@/view/index/index.vue'
import ProductListPage from '@/view/pages/ProductListPage.vue'
import CataloguePage from '@/view/pages/CataloguePage.vue'
import CartPage from '@/view/pages/CartPage.vue'
import CheckoutPage from '@/view/pages/CheckoutPage.vue'
import InquiryPage from '@/view/pages/InquiryPage.vue'
import HelpPage from '@/view/pages/HelpPage.vue'
import AboutPage from '@/view/pages/AboutPage.vue'
import ContactPage from '@/view/pages/ContactPage.vue'
import TextPage from '@/view/pages/TextPage.vue'
import OrdersPage from '@/view/pages/OrdersPage.vue'
import OrderDetailPage from '@/view/pages/OrderDetailPage.vue'
import MyInquiriesPage from '@/view/pages/MyInquiriesPage.vue'
import AddressesPage from '@/view/pages/AddressesPage.vue'
import AccountSettingsPage from '@/view/pages/AccountSettingsPage.vue'
import ShippingCalculatorPage from '@/view/pages/ShippingCalculatorPage.vue'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => {
    if (err && err.name === 'NavigationDuplicated') {
      return err
    }
    throw err
  })
}

export default new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: IndexPage
    },
    {
      path: '/products',
      name: 'products',
      component: ProductListPage
    },
    {
      path: '/catalogue',
      name: 'catalogue',
      component: CataloguePage
    },
    {
      path: '/cart',
      name: 'cart',
      component: CartPage
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: CheckoutPage
    },
    {
      path: '/inquiry',
      name: 'inquiry',
      component: InquiryPage
    },
    {
      path: '/help',
      name: 'help',
      component: HelpPage
    },
    {
      path: '/orders',
      name: 'orders',
      component: OrdersPage
    },
    {
      path: '/orders/detail',
      name: 'order-detail',
      component: OrderDetailPage
    },
    {
      path: '/inquiries',
      name: 'inquiries',
      component: MyInquiriesPage
    },
    {
      path: '/addresses',
      name: 'addresses',
      component: AddressesPage
    },
    {
      path: '/account-settings',
      name: 'account-settings',
      component: AccountSettingsPage
    },
    {
      path: '/about',
      name: 'about',
      component: AboutPage
    },
    {
      path: '/contact',
      name: 'contact',
      component: ContactPage
    },
    {
      path: '/shipping',
      name: 'shipping',
      component: ShippingCalculatorPage
    },
    {
      path: '/terms',
      name: 'terms',
      component: TextPage,
      props: {
        title: 'Terms and Conditions of Use',
        active: 'terms'
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
